<template>
  <ActionMenu
    v-model="showPopup"
    :actions="actions"
    :width="228"
    :teleport="true"
    :closeOnScroll="true"
    :closeOnResize="true"
    placement="bottom-start"
    :offset="8"
    :popupStyle="popupStyle"
    @close="$emit('close')"
    @change="$emit('change', $event)"
    @reorder="$emit('reorder', $event)"
  >
    <template #trigger="{isOpen, toggle}">
      <button
        data-floating-trigger
        type="button"
        :class="[style.navContentSelect, isOpen ? style.active : '']"
        @click.stop="toggle"
      >
        <span>{{ text }}</span>
        <IconBase :icon="chevronDown" tone="tertiary" />
      </button>
    </template>
  </ActionMenu>
</template>

<script lang="ts">
import style from "../NavContentSelect.module.scss";
import {defineComponent, PropType} from "vue";

import IconBase from "@/elements/UI/icon/IconBase.vue";
import ActionMenu from "@/elements/UI/popup/ActionMenu/ActionMenu.vue";

import chevronDown from "$images/icons/button/Name=Chevron-down, Size=16, Tone=Default.svg";

export default defineComponent({
  name: "NavContentSelect",

  components: {
    ActionMenu,
    IconBase
  },

  emits: {
    close: (): boolean => true,

    change: (actions: ListActionItem[]): boolean => {
      return Array.isArray(actions);
    },

    reorder: (payload: ListReorderPayload): boolean => {
      return (
        typeof payload.fromIndex === "number" &&
        typeof payload.toIndex === "number" &&
        Array.isArray(payload.list)
      );
    }
  },

  props: {
    text: {
      type: String,
      default: ""
    },

    actions: {
      type: Array as PropType<ListActionItem[]>,
      default: (): ListActionItem[] => []
    }
  },

  data() {
    return {
      style,
      chevronDown,
      showPopup: false
    };
  },

  computed: {
    popupStyle(): Record<string, string | number> {
      return {
        padding: 0,
        boxSizing: "border-box"
      };
    }
  }
});
</script>
